// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { File } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconFile(props: any) {
    return <IconBase icon={File} {...props} />
  }

  export default IconFile
  